<template>
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_assistenza']"/>

      <!-- Overlay di caricamento -->
      <CustomOverlay :show="overlay_show" text="Invio messaggio...">

        <!-- CARD PRICIPALE DI CONTENIMENTO DI TUTTO IL FORM -->
        <b-card no-body class="mr-1 ml-1">
          <b-card-header>
            <h4><font-awesome-icon icon="info-circle" size="lg"/> Richiedi assistenza</h4>
          </b-card-header>
          <b-card-body>
            <b-form @submit.prevent="onSubmit">
              <!-- DATI UTENTE NOTI -->
              <!-- Cognome -->
              <b-form-group id="group-cognome"
              label="Cognome:"
              label-for="cognome">
                <b-form-input
                  id="cognome"
                  v-model="form.cognome"
                  :disabled="true"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Nome -->
              <b-form-group id="group-nome"
              label="Nome:"
              label-for="nome">
                <b-form-input
                  id="nome"
                  v-model="form.nome"
                  :disabled="true"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Azienda -->
              <b-form-group id="group-azienda"
              label="Azienda:"
              label-for="azienda">
                <b-form-input
                  id="azienda"
                  v-model="form.azienda"
                  :disabled="true"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Email -->
              <b-form-group id="group-email"
              label="Email:"
              label-for="email">
                <b-form-input
                  id="email"
                  v-model="form.email"
                  :disabled="true"
                  type="email"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- DATI DA COMPILARE -->
              <!-- Telefono -->
              <b-form-group id="group-tel"
                label="* Telefono:"
                label-for="tel"
                :invalidFeedback="invalid_tel_helptext">
                <b-form-input
                  id="tel"
                  v-model="form.tel"
                  :state="form_state.tel"
                  placeholder="Inserire un recapito telefonico"
                  type="tel"
                  required
                ></b-form-input>
              </b-form-group>

              <!-- Numero richiesta welfare -->
              <b-form-group id="group-n-richiesta"
                label="Richiesta N°:"
                label-for="n_richiesta"
                :invalidFeedback="invalid_tel_helptext"
                description="Se la richiesta di assistenza è relativa ad un pratica welfare inviata, inserirne il numero identificativo.">
                <b-form-input
                  id="n_richiesta"
                  v-model="form.n_richiesta"
                  placeholder="Inserire l'id della pratica welfare"
                  type="number">
                </b-form-input>
              </b-form-group>

              <!-- Categoria welfare -->
              <b-form-group id="group-categoria"
                label="* Categoria:"
                label-for="categoria"
              >
                <b-form-select id="categoria"
                  v-model="form.categoria"
                  :options="categorie_welfare"
                  required>
                  </b-form-select>
              </b-form-group>

              <!-- Messaggio da inviare -->
              <b-form-group id="group-messaggio"
                label="* Messaggio:"
                label-for="messaggio">
                <b-form-textarea
                  id="messaggio"
                  v-model="form.messaggio"
                  placeholder="Scrivi qui il messaggio da inviare"
                  rows="10"
                  required>
                </b-form-textarea>
              </b-form-group>


              <!-- File da allegare -->
              <b-form-group id="group-file"
              label="Allega un file alla tua segnalazione ( formati accettati: pdf, jpg, jpeg, png )"
              label-for="file">
              <b-form-file
                id="file"
                v-model="form.file_data"
                placeholder="Scegli o trascina qui un file"
                drop-placeholder="Rilascia qui il file"
                accept=".jpg, .png, .pdf"
                browse-text ="Seleziona">
              </b-form-file>
              </b-form-group>

            <!-- Pulsante di invio -->
            <b-button type="submit" variant="primary" class="mr-1">Invia</b-button>

            </b-form>
          </b-card-body>

        </b-card>
      </CustomOverlay>
  </div>
</template>

<script>
import CustomOverlay from '@/components/CustomOverlay'
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'FormAssistenza',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Richiedi Assistenza", link : 'helpform' } ],
      overlay_show : false,

      // Categorie tra le quali scegliere.
      // TODO/FIXME: Ora carichiamo staticamente questa lista, poi dovremmo caricarla in maniera
      // dinamica a seconda dei permessi che l'utente ha.
      categorie_welfare : [
        { value: null, text: "Seleziona una categoria", disabled: true },
        { value : "[ Rimborsi ] Spese", text: "[ Rimborsi ] Spese" },
        { value : "[ Rimborsi ] Interessi", text: "[ Rimborsi ] Interessi" },
        { value : "[ Buoni ] Welfarebit", text: "[ Buoni ] Welfarebit" },
        { value : "[ Buoni ] Welfarebit 10", text: "[ Buoni ] Welfarebit 10" },
        { value : "[ Convenzioni ] Esperienze", text: "[ Convenzioni ] Esperienze" },
        { value : "[ Convenzioni ] Viaggi su misura", text: "[ Convenzioni ] Viaggi su misura" },
        { value : "[ Convenzioni ] Parchi di Divertimento", text: "[ Convenzioni ] Parchi di Divertimento" },
        { value : "[ Welfare Sociale ] Previdenza integrativa", text: "[ Welfare Sociale ] Previdenza integrativa" },
        { value : "[ Welfare Sociale ] Assistenza sanitaria integrativa", text: "[ Welfare Sociale ] Assistenza sanitaria integrativa" },
        { value : "Altre informazioni", text: "Altre informazioni" }
      ],

      // Dati del form
      form : {
        cognome : null,
        nome : null,
        azienda : null,
        email : null,
        tel: null,
        n_richiesta : null,
        categoria : null,
        messaggio: null,
        file_data : null
      },

      // Stato dei campi del form
      // ( solo campi che lo richiedono )
      form_state : {
        tel : null
      }
    }
  },
  computed : {
    /**
     * Se lo stato del numero di telefono non è corretto visualizziamo il testo di help
     * per l'utente.
     */
    invalid_tel_helptext : function () {
      if ( this.form_state.tel === false ){
        return 'Il numero di telefono non può contenere lettere.';
      } else {
        return '';
      }
    }
  },
  methods : {
    onSubmit : function () {

      // Controlliamo lo stato del capo del numero di telefono
      if ( this.form_state.tel !== true ) {
        generalLib.backend_error_message_box( this, 'Controllare il numero di telefono, il campo non è stato compilato o non è valido' );
        return;
      }

      // Aggiugo ai campi da inviare solo quello che serve realmente, i dati utente
      // infatti non servono perchè li prendo dall'anagrafica grazie all'uid presente
      // nell'oggetto request di Django.
      // I dati sono inviati in un oggetto javascript FormData e poi inviati come
      // multipartm questo è necessario perchè se c'è il file dobbiamo inviare i suoi
      // dati binari.
      // I multipart come il form-data, non hanno come il json il concetto di
      // conversione dei null in None, ma si limitano a convertire il null nel
      // suo corrispettivo unicode 'null' facendo saltare la validazione lato Django.
      // Per questo i campi che sono null li convertiamo in stringa vuota
      // cosi che  Django Rest nel serializzatore li riconverta in None.
      let data_to_send = new FormData();

      let tel = this.form.tel === null ? '' : this.form.tel;
      data_to_send.append( 'tel', tel );

      let n_richiesta = this.form.n_richiesta === null ? '' : this.form.n_richiesta;
      data_to_send.append( 'n_richiesta', n_richiesta );

      let categoria = this.form.categoria === null ? '' : this.form.categoria;
      data_to_send.append( 'categoria', categoria );

      let messaggio = this.form.messaggio === null ? '' : this.form.messaggio;
      data_to_send.append( 'messaggio', messaggio );

      let file_data = this.form.file_data === null ? '' : this.form.file_data;
      data_to_send.append( 'file_data', file_data );

      // Overlay di attesa invio
      this.overlay_show = true;

      axios.post( apiUrl.mailapi.send_support_mail , data_to_send )
      .then( (response) => {

        this.overlay_show = false;
        let mess = "Abbiamo ricevuto il tuo messaggio, sarà nostra cura risponderti nel più breve tempo possibile.";

        this.$bvModal.msgBoxOk( mess , {
          title: 'Messaggio inviato',
          buttonSize: 'sm',
          okVariant: 'success',
          centered: true
        })
        .then( ( value ) => {
          this.$router.push( { name : 'menu'} );
        })
        .catch( ( err ) => {
          console.error(  err );
        });

      })
      .catch( (error) => {
          this.overlay_show = false;
          generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  /**
   * Alla creazione del form prendiamo dallo store i dati utente per riempire i campi noti.
   */
  created : function () {
    this.form.cognome = this.$store.state.user.user_anag.cognome;
    this.form.nome = this.$store.state.user.user_anag.nome;
    this.form.email = this.$store.state.user.user_anag.email;

    let azi_type = this.$store.state.user.user_azi.cognome === null ? "" : this.$store.state.user.user_azi.cognome;
    this.form.azienda = this.$store.state.user.user_azi.nome + ' ' + azi_type;

  },
  watch : {
    /**
     * Controlliamo e validiamo il telefono con la proprità state del form
     * ammettiamo numeri e simboli, non ammettiamo lettere.
     */
    'form.tel' : function ( val ) {
      if ( val === '' ) {
        this.form_state.tel = null;
      } else if ( generalLib.phone_is_valid( val ) ) {
        this.form_state.tel = true;
      } else {
        this.form_state.tel = false;
      }
    }
  },
  components : {
    PageTagline,
    TutorialContestuale,
    CustomOverlay
  }
}
</script>

<style scoped></style>